import { z } from "zod";

const apiErrorBodySchema = z.object({ message: z.string(), field: z.string().optional() }).passthrough();
export type ApiErrorBody = z.infer<typeof apiErrorBodySchema>;

export function apiErrorBody(message: string, field?: string): ApiErrorBody {
  return field === undefined ? { message } : { message, field };
}

export function parseApiErrorBody(text: string): ApiErrorBody | null {
  try {
    const parsed = apiErrorBodySchema.safeParse(JSON.parse(text));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
